module.exports = __webpack_public_path__ + "static/media/refer.f181fca7.png";